import type { FunctionComponent } from 'react';
import type { ModalMode } from '../../organisms/eventContentsSection/types';

type Props = {
  isOpen: boolean;
  mode: ModalMode;
  eventTitle: string;
  startDate?: string;
  startTime?: string;
  endTime?: string;
  place?: string;
  isProcessing: boolean;
  onConfirm: () => void;
  onClose: () => void;
  onCancel?: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  isOpen,
  mode,
  eventTitle,
  startDate,
  startTime,
  endTime,
  place,
  isProcessing,
  onConfirm,
  onClose,
  onCancel,
}) => {
  if (!isOpen) return null;

  const isConfirmMode = mode === 'confirm' || mode === 'cancelled_confirm';
  const isCancelMode = mode === 'complete' || mode === 'cancelled_complete';
  const isCancelAction = mode === 'cancelled_confirm' || mode === 'cancelled_complete';

  const buttonText = isCancelAction ? 'キャンセル' : '申し込み';
  const completeText = isCancelAction
    ? 'キャンセルが完了しました'
    : '申し込みが完了しました';

  const handleConfirm = isCancelAction && onCancel ? onCancel : onConfirm;

  return (
    <>
      {isConfirmMode && (
        <div className="event-contents-modal is-active">
          <div className="event-contents-modal-heading">
            {eventTitle}
            <br />
            {isCancelAction ? 'をキャンセルします' : 'に申し込みます'}
            <i
              className="fas fa-times event-contents-modal-heading-icon"
              onClick={onClose}
            />
          </div>
          <div className="event-contents-modal-contents">
            <div className="event-contents-modal-contents-inner">
              <span className="event-contents-modal-contents-title">開催概要</span>
              <br />
              <br />
              <span className="event-contents-modal-contents-date">
                {startDate}
              </span>
              <br />
              <span className="event-contents-modal-contents-time">
                {startTime} - {endTime}
              </span>
              <br />
              <span className="event-contents-modal-contents-place">
                {place}
              </span>
              <br />
            </div>
          </div>
          <div className="event-contents-modal-apply">
            <input
              type="button"
              className="event-contents-modal-apply-btn gtm-popup_entry-view-count"
              value={buttonText}
              data-event-name="popup_entry on screen"
              data-event="click"
              data-category="eventcontent"
              data-value="popup_entry_event"
              onClick={handleConfirm}
              disabled={isProcessing}
            />
          </div>
        </div>
      )}

      {isCancelMode && (
        <div className="event-contents-modal-complete is-active">
          <div className="event-contents-modal-complete-heading">
            {completeText}
            <i
              className="fas fa-times event-contents-modal-complete-heading-icon"
              onClick={onClose}
            />
          </div>
        </div>
      )}

      <div className="event-contents-overlay is-active" onClick={onClose} />
    </>
  );
};
